const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="1.34424"
      y="0.5"
      width="20"
      height="20"
      rx="10"
      fill="#3498DB"
      stroke="#3498DB"
    />
    <path
      d="M12.8758 16H10.32V9.05143H12.8758V16ZM11.5979 4C12.4797 4 13.1953 4.6656 13.1953 5.48571C13.1953 6.30583 12.4797 6.97143 11.5979 6.97143C10.7161 6.97143 10.0005 6.30583 10.0005 5.48571C10.0005 4.6656 10.7161 4 11.5979 4Z"
      fill="white"
    />
  </svg>
);

export default InfoIcon;
